import React, { useMemo } from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldTypes,
  FieldWrapper,
  FlexRadioGroup,
  InfoOutlineIcon,
  Label,
  Text,
  useFormContext,
} from '@common-fe/common-fe';

import { CLOSE_CONTRIBUTION_SIDE, EmployeeCIPCloseContributionForm } from '../cip.constants';

import { useGetTransactionsInfoQuery } from './queries';

interface Props {
  accountId: string;
}
const EmployeeCIPCloseContirubtionForm: React.FC<Props> = ({ accountId }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<EmployeeCIPCloseContributionForm>();
  const { isPendingPresent, isTotalPresent } = useGetTransactionsInfoQuery({
    accountId,
  });

  const isRadioDisabled = useMemo(
    () => !isTotalPresent && isPendingPresent,
    [isPendingPresent, isTotalPresent]
  );
  return (
    <Box
      background="canvas"
      pad="spacing24"
      data-testid="cip_contribution_to_wrapper"
      round="container1Round"
      border={{ size: 'small', color: 'border2' }}
      direction="column"
    >
      <FieldWrapper align="start">
        <Label name="roleName" isNarrow={true}>
          Return contribution to
        </Label>
        <ControllerWrapper errorText={errors?.contributionTo?.message}>
          <Controller
            name="contributionTo"
            control={control}
            render={({ field }) => (
              <Box width={{ max: 'medium' }}>
                <FlexRadioGroup
                  label="Contribution to"
                  name={field.name}
                  value={isRadioDisabled ? CLOSE_CONTRIBUTION_SIDE.EMPLOYEE : field.value}
                  disabled={isRadioDisabled}
                  options={[
                    {
                      label: 'Employer',
                      value: CLOSE_CONTRIBUTION_SIDE.EMPLOYER,
                    },
                    {
                      label: 'Employee',
                      value: CLOSE_CONTRIBUTION_SIDE.EMPLOYEE,
                    },
                  ]}
                  onChange={field.onChange}
                  error={!!errors?.contributionTo?.message}
                  testId="cip_contribution_to"
                  type={FieldTypes.Radio}
                />
              </Box>
            )}
          />
        </ControllerWrapper>
      </FieldWrapper>
      {isPendingPresent && (
        <Box
          background="infoContainer"
          round="container1Round"
          data-testid="cip_transfer"
          margin={{ top: 'spacing16' }}
          pad={{
            vertical: 'spacing24',
            horizontal: 'spacing32',
          }}
          border={{ size: 'small', color: 'infoBorder' }}
          style={{ position: 'relative' }}
        >
          <Box
            height="2px"
            background="info"
            style={{ left: '32px', right: '32px', top: '-1px', position: 'absolute' }}
          />
          <Box direction="row" align="center">
            <InfoOutlineIcon color="info" size="24px" />
            <Text size="large" weight={700} margin={{ left: 'spacing8' }}>
              Transfer credits must be returned directly to the employee
            </Text>
          </Box>

          <Text margin={{ top: 'spacing8' }} weight={400}>
            Pending transfer credits are a result of an inbound Transfer of Assets (TOA). These funds will be
            returned directly to the employee regardless of where the contributions are returned.
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default EmployeeCIPCloseContirubtionForm;
